module.exports = __webpack_public_path__ + "img/IDcardau.c4fc0ec3.png";